export default __webpack_public_path__ + "a12fdaa39f1edbf54a8a60928a1af45c.png";